import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { Booking } from "../app/Bookings/model";

interface BookingData {
  guests: number;
  pricing: Booking["offerYacht"]["pricing"];
  amenitiesDetails: Booking["offerYacht"]["amenitiesDetails"];
}

const updateBookingGuestsCount = async (bookingId: string, body: BookingData) => {
  return fetch(`/api/bookings/${bookingId}/guests`, "PATCH", body);
};

export const useBookingGuestsCountMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { body: BookingData; toastId: any }) => updateBookingGuestsCount(bookingId, data.body),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Guests number updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking guests number!",
        variant: "destructive",
      });
    },
  });
};
